var render = function render(){var _vm=this,_c=_vm._self._c;return (
    !_vm.cookiesAccepted &&
    !['/privacy-policy', '/cookie-policy'].includes(_vm.$route.path)
  )?_c('div',{staticClass:"alert alert-info fixed-bottom m-0",attrs:{"id":"cookieConsent"}},[_c('div',{staticClass:"container text-center"},[_c('span',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t("cookie_alert_text"))+" "),_c('router-link',{attrs:{"to":"/cookie-policy","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("cookie_policy")))]),_vm._v(". ")],1),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.acceptCookies}},[_vm._v(" "+_vm._s(_vm.$t("i_agree"))+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }